import PartnerUrgentCare from './PartnerUrgentCare';
import PartnerPediatricUrgentCare from './PartnerPediatricUrgentCare';
import DefaultCDPInfo from './DefaultCDPInfo';
import {
  isSolvPartner,
  isUrgentCare,
  isPediatricUrgentCare,
  isTelemedLocation,
  isUrgentCareV1,
  isUrgentCareV2,
  isUrgentCareV3,
  isRetailClinic,
  isPrimaryCare,
  isOccupationalHealth,
  isEmergencyRoom,
  isTelehealth,
  isSpecialtyUrgentCare,
  isTraditionalLocation,
} from '../../../core/util/location';
import PartnerTelemedVideoVisit from './PartnerTelemedVideoVisit';
import NonPartnerUrgentCareV1 from './NonPartnerUrgentCareV1';
import NonPartnerUrgentCareV2 from './NonPartnerUrgentCareV2';
import NonPartnerUrgentCareV3 from './NonPartnerUrgentCareV3';
import NonPartnerPediatricUrgentCare from './NonPartnerPediatricUrgentCare';
import NonPartnerRetailClinic from './NonPartnerRetailClinic';
import NonPartnerPrimaryCare from './NonPartnerPrimaryCare';
import NonPartnerOccupationalHealth from './NonPartnerOccupationalHealth';
import NonPartnerEmergencyRoom from './NonPartnerEmergencyRoom';
import NonPartnerSpecialtyUrgentCare from './NonPartnerSpecialtyUrgentCare';
import Traditional from './Traditional';
import { safeGet } from '../../../core/util/object';

class CDPInfoFactory {
  static buildFromLocation(location, nearbyLocations, properties) {
    const userAgent = safeGet(properties)('userAgent');
    if (isTraditionalLocation(location)) {
      return new Traditional(location, { userAgent });
    }

    if (isSolvPartner(location)) {
      if (isTelemedLocation(location) || isTelehealth(location)) {
        return new PartnerTelemedVideoVisit(location, nearbyLocations, { userAgent });
      } else if (isPediatricUrgentCare(location)) {
        return new PartnerPediatricUrgentCare(location, nearbyLocations, { userAgent });
      } else if (isUrgentCare(location)) {
        return new PartnerUrgentCare(location, nearbyLocations, { userAgent });
      }
    }

    if (!isSolvPartner(location)) {
      if (isPediatricUrgentCare(location)) {
        return new NonPartnerPediatricUrgentCare(location, nearbyLocations, { userAgent });
      } else if (isRetailClinic(location)) {
        return new NonPartnerRetailClinic(location, nearbyLocations, { userAgent });
      } else if (isPrimaryCare(location)) {
        return new NonPartnerPrimaryCare(location, nearbyLocations, { userAgent });
      } else if (isOccupationalHealth(location)) {
        return new NonPartnerOccupationalHealth(location, { userAgent });
      } else if (isEmergencyRoom(location)) {
        return new NonPartnerEmergencyRoom(location, { userAgent });
      } else if (isSpecialtyUrgentCare(location)) {
        return new NonPartnerSpecialtyUrgentCare(location, { userAgent });
      } else if (isUrgentCareV1(location)) {
        return new NonPartnerUrgentCareV1(location, nearbyLocations, { userAgent });
      } else if (isUrgentCareV2(location)) {
        return new NonPartnerUrgentCareV2(location, nearbyLocations, { userAgent });
      } else if (isUrgentCareV3(location)) {
        return new NonPartnerUrgentCareV3(location, nearbyLocations, { userAgent });
      }
    }

    return new DefaultCDPInfo(location, { userAgent });
  }
}

export default CDPInfoFactory;
